'use client';

import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { useInitialize, useTheme } from '../../hooks';
import { Card, Stack } from '@mui/material';
import { MarkdownText } from '../../types';
import NotFound from '../../app/[locale]/(digitalHub)/not-found';
import { Column, HeadlineSmall } from '../../styles';
import { fetchAbout } from '../../api/about/fetchAboutText';

const AboutScreen = () => {
    const theme = useTheme();
    const [about, setAbout] = useState<MarkdownText | null>(null);
    const [hasError, setHasError] = useState<boolean>(false);

    useInitialize(() => {
        fetchAbout()
            .then((response) => {
                setAbout(response.about);
                setHasError(response.error !== undefined);
            })
            .catch((error) => {
                console.error(error);
            });
    });

    if (hasError) return <NotFound />;
    if (!about) return null;

    return (
        <Stack spacing={theme.spacing(3)} pb={4}>
            <Card sx={{ px: 3, py: 1 }}>
                <Column gap={3}>
                    <HeadlineSmall color='primary'>Über uns</HeadlineSmall>
                    <ReactMarkdown>{about.replaceAll('\n', '  \n ')}</ReactMarkdown>
                </Column>
            </Card>
        </Stack>
    );
};

export { AboutScreen };
